<template>
	<div class="content-inner"  v-if="view == 'import'">
		<x-panel alt>
			<div slot="title">CSV Import</div>
			<div slot="extra">
				<a :href="`/`" download class="btn btn-default">Download Example CSV</a>
			</div>
			<div class="import-form">
				<slot></slot>
                <div>
                    <div class="col-md-6">
                    	<b-form-file ref="file" :state="Boolean(file)" :name="`csv_file`" placeholder="Select CSV to upload..." v-on:change="handleFileUpload()"></b-form-file>
                    </div>
                </div>
			</div>
			<div slot="footer" class="flex flex-end panel-footer">
				<div>
					<button v-on:click="submitFile()" class="btn btn-primary">Upload CSV</button>
				</div>
			</div>
		</x-panel>
	</div>

	<div class="content-inner"  v-else-if="view == 'parsing'">
		<x-panel alt>
			<div class="panel-heading">
				<div class="panel-title">
					<div>
						<div>
							Select Fields to Map
						</div>
					</div>
				</div>
				<div class="panel-extra">
					<div>
						<div>
							<button class="btn btn-default btn-sm" v-on:click="reset()"><small class="icon icon-arrow-left-c"></small></button>
						</div>
					</div>
				</div>
			</div>
			<p class="inline-help">Select which fields you wish to synchronize to their destinations.</p>
			<b-form :id="`processImport`" @submit.prevent="processImport">
				<table class="import-table">
					<tr class="table-header">
						<td width="250">Column To Import</td>
						<td>Map Into Field</td>
					</tr>
					<x-tr v-for="(value, key) in parsed.header_fields" :key="key">
					    <x-td class="name-import">{{value}}</x-td>
					    <x-td class="map-import">
					    	<select :name="`fields[${key}]`">
	                            <option v-for="(importItem, importKey) in parsed.db_fields" v-bind:value="importItem" v-bind:selected="importItem == value">{{ importItem }}</option>
	                        </select>
					    </x-td>
					</x-tr>
				</table>
				<div slot="footer" class="panel-footer flex flex-end">
					<div>
						<b-button type="submit" class="btn btn-primary">Parse CSV</b-button>
					</div>
				</div>
			</b-form>
		</x-panel>
	</div>
	<div class="content-inner"  v-else-if="view == 'success'">
		<x-panel alt>
			<div slot="title">
				<slot name="title">Import Successful</slot>
			</div>
			<div slot="extra">
				<slot name="extra"></slot>
			</div>
			<div slot="footer" class="flex flex-end">
				<div>
					<button v-on:click="finish()" class="btn btn-primary">Finish</button>
				</div>
			</div>
		</x-panel>
	</div>
</template>
<script>
	export default {
		name: 'XImport',
	  	data() {
	  		return {
	        	file: '',
	        	view: 'import',
	        	parsed: [],
	        	output: '',
	        	csv_data_file_id: ''
	  		}
	  	},
	    computed: {
	    },
	    mounted() {
	 		this.$bar.finish()
		},
	  	methods: {
	  		reset() {
	  			this.view = 'import'
	  		},
	  		handleFileUpload(){
		    	this.file = this.$refs.file.$refs.input.files[0];
		  	},
		  	submitFile(){
		  		let formData = new FormData();
		  		const vm = this;
		  		formData.append('csv_file', this.file);

				this.$alertmsg({
		          message: 'Uploading',
		          type: 'loading',
		          showClose: false,
		          align: 'center',
		        });

		  		this.$tenant.post( '/admin/import/import_parse',
			        formData,{
		                headers: {
		                    'Content-Type': 'multipart/form-data'
		                }
		            }).then(function($res){
				        vm.$alertmsg.closeAll();
				        vm.parsed = $res.data;
				        vm.csv_data_file_id = $res.data.csv_data_file.id;
		            	vm.view = 'parsing';
			        }).catch(function(err){
			        	vm.view = 'error';
                        err.output()
			        });
			    },
			processImport(e) {
      			e.preventDefault();
      			this.$tenant.options.emulateJSON = true;
				let importFields = document.getElementById('processImport');
      			let formData = new FormData(importFields);

      			this.$alertmsg({
					message: 'Importing',
					type: 'loading',
					showClose: false,
					align: 'center',
		        });

      			formData.append('csv_data_file_id', this.csv_data_file_id);
      			this.$tenant.post( '/admin/import/import_process',
		        formData,{
	                headers: {
	                    'Content-Type': 'multipart/form-data'
	                }
	            }).then(function($res){
			        vm.$alertmsg.closeAll();
			        vm.view = 'success';
			        this.file = '';
		        	this.parsed = '';
		        	this.output = '';
		        	this.csv_data_file_id = '';
		        }).catch(function(err){
		        	vm.view = 'error';
                    err.output()
		        });
			},
			finish() {
				this.view = 'import';
			}
		},
  	}
</script>
